import Styles from "./Stats.module.css";

/**
 * TextGrid — `stats` variation. Source: `.stat-bar`.
 * A credential band: value + label, four across, hairline separated.
 * No section heading by design, so the region carries a hardcoded aria-label —
 * an authorable one would ship blank and leave the region unnamed.
 */
const Stats = ({ primary, items }) => {
	return (
		<section
			className={Styles.wrapper}
			data-theme={primary?.dark_theme ? "dark" : "light"}
			aria-label="Key statistics">
			<div
				className={Styles.container}
				data-contain="true">
				<ul className={Styles.grid}>
					{items?.map((item, index) => (
						<li
							className={Styles.stat}
							key={index}>
							<p className={Styles.value}>
								{item?.value}
								{item?.suffix && (
									<sup className={Styles.suffix}>{item?.suffix}</sup>
								)}
							</p>
							<p className={Styles.label}>{item?.label}</p>
						</li>
					))}
				</ul>
			</div>
		</section>
	);
};

export default Stats;
